import axios from "axios";

function collectData(data) {
  let uavData;
  let UAVUpPicture = {
    uavMappingUrl: [],
    uavUrl: []
  };
  if (data.hasOwnProperty("data")) {
    if (typeof data.data == "string") {
      data.data = JSON.parse(data.data);
    }
    //旧数据
    if (data.data.hasOwnProperty("wurenji")) {
      if (typeof data.data.wurenji == "string") {
        data.data.wurenji = JSON.parse(data.data.wurenji);
      }

      if (data.data.wurenji.hasOwnProperty("kongyu")) {
        data.data.wurenji.airspace = data.data.wurenji.kongyu;
      }
      if (data.data.wurenji.hasOwnProperty("cehuianli")) {
        data.data.wurenji.mappingCase = data.data.wurenji.cehuianli;
      }
      if (data.data.wurenji.hasOwnProperty("chuanganqi")) {
        data.data.wurenji.sensor = data.data.wurenji.chuanganqi;
      }
      if (data.data.wurenji.hasOwnProperty("keshengqingkongyu")) {
        data.data.wurenji.applicableAirspace =
          data.data.wurenji.keshengqingkongyu;
      }
      if (data.data.wurenji.hasOwnProperty("kongyuxingxi")) {
        data.data.wurenji.airspaceDetails = data.data.wurenji.kongyuxingxi;
      }

      if (data.data.wurenji.hasOwnProperty("mappingUrl")) {
        if (data.data.wurenji.mappingUrl != "") {
          let urlobj = {
            name: data.data.wurenji.mappingUrl,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.mappingUrl
          };
          UAVUpPicture.uavMappingUrl.push(urlobj);
        }
      }
      if (data.data.wurenji.hasOwnProperty("mappingUrl1")) {
        if (data.data.wurenji.mappingUrl1 != "") {
          let urlobj = {
            name: data.data.wurenji.mappingUrl1,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.mappingUrl1
          };
          UAVUpPicture.uavMappingUrl.push(urlobj);
        }
      }
      if (data.data.wurenji.hasOwnProperty("mappingUrl2")) {
        if (data.data.wurenji.mappingUrl2 != "") {
          let urlobj = {
            name: data.data.wurenji.mappingUrl2,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.mappingUrl2
          };
          UAVUpPicture.uavMappingUrl.push(urlobj);
        }
      }
      if (data.data.wurenji.hasOwnProperty("mappingUrl3")) {
        if (data.data.wurenji.mappingUrl3 != "") {
          let urlobj = {
            name: data.data.wurenji.mappingUrl3,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.mappingUrl3
          };
          UAVUpPicture.uavMappingUrl.push(urlobj);
        }
      }
      if (data.data.wurenji.hasOwnProperty("wurenjizhengshu")) {
        if (data.data.wurenji.wurenjizhengshu != "") {
          let urlobj = {
            name: data.data.wurenji.wurenjizhengshu,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.wurenjizhengshu
          };
          UAVUpPicture.uavUrl.push(urlobj);
        }
      }
      if (data.data.wurenji.hasOwnProperty("wurenjizhengshu1")) {
        if (data.data.wurenji.wurenjizhengshu1 != "") {
          let urlobj = {
            name: data.data.wurenji.wurenjizhengshu1,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.wurenjizhengshu1
          };
          UAVUpPicture.uavUrl.push(urlobj);
        }
      }
      if (data.data.wurenji.hasOwnProperty("wurenjizhengshu2")) {
        if (data.data.wurenji.wurenjizhengshu2 != "") {
          let urlobj = {
            name: data.data.wurenji.wurenjizhengshu2,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.wurenjizhengshu2
          };

          UAVUpPicture.uavUrl.push(urlobj);
        }
      }
      if (data.data.wurenji.hasOwnProperty("wurenjizhengshu3")) {
        if (data.data.wurenji.wurenjizhengshu3 != "") {
          let urlobj = {
            name: data.data.wurenji.wurenjizhengshu3,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.wurenji.wurenjizhengshu3
          };

          UAVUpPicture.uavUrl.push(urlobj);
        }
      }
    }
    //新数据
    if (data.data.hasOwnProperty("UAV")) {
      if (typeof data.data.UAV == "string") {
        data.data.UAV = JSON.parse(data.data.UAV);
      }
      if (data.data.UAV.hasOwnProperty("uavMappingUrl")) {
        let stringResult = data.data.UAV.uavMappingUrl.split(",");
        stringResult.forEach(e => {
          let urlobj = {
            name: e,
            url: axios.defaults.baseURL + "file" + "/" + e
          };
          UAVUpPicture.uavMappingUrl.push(urlobj);
        });
      }
      if (data.data.UAV.hasOwnProperty("uavUrl")) {
        let stringResult = data.data.UAV.uavUrl.split(",");
        stringResult.forEach(e => {
          let urlobj = {
            name: e,
            url: axios.defaults.baseURL + "file" + "/" + e
          };
          UAVUpPicture.uavUrl.push(urlobj);
        });
      }
    }
  }

  uavData = data;
  return { uavData, UAVUpPicture };
}
function mannedCollectData(data) {
  let mannedData;
  let mannedUpPicture = {
    mannedMappingUrl: [],
    mannedUrl: []
  };
  if (data.hasOwnProperty("data")) {
    if (typeof data.data == "string") {
      data.data = JSON.parse(data.data);
    }
    //旧数据
    if (data.data.hasOwnProperty("yourenji")) {
      if (typeof data.data.yourenji == "string") {
        data.data.yourenji = JSON.parse(data.data.yourenji);
      }

      if (data.data.yourenji.hasOwnProperty("kongyu")) {
        data.data.yourenji.airspace = data.data.yourenji.kongyu;
      }
      if (data.data.yourenji.hasOwnProperty("cehuianli")) {
        data.data.yourenji.mappingCase = data.data.yourenji.cehuianli;
      }
      if (data.data.yourenji.hasOwnProperty("chuanganqi")) {
        data.data.yourenji.sensor = data.data.yourenji.chuanganqi;
      }
      if (data.data.yourenji.hasOwnProperty("keshengqingkongyu")) {
        data.data.yourenji.applicableAirspace =
          data.data.yourenji.keshengqingkongyu;
      }
      if (data.data.yourenji.hasOwnProperty("kongyuxingxi")) {
        data.data.yourenji.airspaceDetails = data.data.yourenji.kongyuxingxi;
      }
      if (data.data.yourenji.hasOwnProperty("shihangxuke")) {
        data.data.yourenji.airworthinessPermit = data.data.yourenji.shihangxuke;
      }

      if (data.data.yourenji.hasOwnProperty("mappingUrl")) {
        if (data.data.yourenji.mappingUrl != "") {
          let urlobj = {
            name: data.data.yourenji.mappingUrl,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.mappingUrl
          };
          mannedUpPicture.mannedMappingUrl.push(urlobj);
        }
      }
      if (data.data.yourenji.hasOwnProperty("mappingUrl1")) {
        if (data.data.yourenji.mappingUrl1 != "") {
          let urlobj = {
            name: data.data.yourenji.mappingUrl1,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.mappingUrl1
          };
          mannedUpPicture.mannedMappingUrl.push(urlobj);
        }
      }
      if (data.data.yourenji.hasOwnProperty("mappingUrl2")) {
        if (data.data.yourenji.mappingUrl2 != "") {
          let urlobj = {
            name: data.data.yourenji.mappingUrl2,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.mappingUrl2
          };
          mannedUpPicture.mannedMappingUrl.push(urlobj);
        }
      }
      if (data.data.yourenji.hasOwnProperty("mappingUrl3")) {
        if (data.data.yourenji.mappingUrl3 != "") {
          let urlobj = {
            name: data.data.yourenji.mappingUrl3,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.mappingUrl3
          };
          mannedUpPicture.mannedMappingUrl.push(urlobj);
        }
      }

      if (data.data.yourenji.hasOwnProperty("wurenjizhengshu")) {
        if (data.data.yourenji.wurenjizhengshu != "") {
          let urlobj = {
            name: data.data.yourenji.wurenjizhengshu,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.wurenjizhengshu
          };
          mannedUpPicture.mannedUrl.push(urlobj);
        }
      }
      if (data.data.yourenji.hasOwnProperty("wurenjizhengshu1")) {
        if (data.data.yourenji.wurenjizhengshu1 != "") {
          let urlobj = {
            name: data.data.yourenji.wurenjizhengshu1,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.wurenjizhengshu1
          };
          mannedUpPicture.mannedUrl.push(urlobj);
        }
      }
      if (data.data.yourenji.hasOwnProperty("wurenjizhengshu2")) {
        if (data.data.yourenji.wurenjizhengshu2 != "") {
          let urlobj = {
            name: data.data.yourenji.wurenjizhengshu2,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.wurenjizhengshu2
          };

          mannedUpPicture.mannedUrl.push(urlobj);
        }
      }
      if (data.data.yourenji.hasOwnProperty("wurenjizhengshu3")) {
        if (data.data.yourenji.wurenjizhengshu3 != "") {
          let urlobj = {
            name: data.data.yourenji.wurenjizhengshu3,
            url:
              axios.defaults.baseURL +
              "file" +
              "/" +
              data.data.yourenji.wurenjizhengshu3
          };

          mannedUpPicture.mannedUrl.push(urlobj);
        }
      }
    }
    //新数据
    if (data.data.hasOwnProperty("manned")) {
      if (typeof data.data.manned == "string") {
        data.data.manned = JSON.parse(data.data.manned);
      }
      if (data.data.manned.hasOwnProperty("mannedMappingUrl")) {
        let stringResult = data.data.manned.mannedMappingUrl.split(",");
        stringResult.forEach(e => {
          let urlobj = {
            name: e,
            url: axios.defaults.baseURL + "file" + "/" + e
          };
          mannedUpPicture.mannedMappingUrl.push(urlobj);
        });
      }
      if (data.data.manned.hasOwnProperty("mannedUrl")) {
        let stringResult = data.data.manned.mannedUrl.split(",");
        stringResult.forEach(e => {
          let urlobj = {
            name: e,
            url: axios.defaults.baseURL + "file" + "/" + e
          };
          mannedUpPicture.mannedUrl.push(urlobj);
        });
      }
    }
  }

  mannedData = data;
  return { mannedData, mannedUpPicture };
}

export { collectData, mannedCollectData };
